import { render, staticRenderFns } from "./PageNotFoundCard.vue?vue&type=template&id=bb8111ca&scoped=true&"
import script from "./PageNotFoundCard.vue?vue&type=script&lang=js&"
export * from "./PageNotFoundCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb8111ca",
  null
  
)

export default component.exports